import { create } from "zustand";

import type { PreviewScenario } from "@/api";

/**
 * Client state only (UI architecture §3): who is working, and which sample
 * intake response the demo shows. No case data is mirrored here — that lives
 * in React Query and comes from the backend.
 */
interface SessionState {
  /**
   * Name recorded on confirmations. Filled from the signed-in user's
   * `displayName` by one effect in `AppShell` (task 13) — nothing else
   * writes it at runtime. `setReviewer` stays exported for tests that need
   * a reviewer without mounting the shell.
   *
   * Empty until that effect has run once, e.g. mid-`useMe()` fetch: it used
   * to default to a real colleague's first name, which made every
   * confirmation name that colleague no matter who clicked — a
   * fabricated provenance, and about an actual person. Empty is the honest
   * value for that gap; the screens render a neutral „Bestätigt." for it.
   */
  reviewer: string;
  scenario: PreviewScenario;
  setReviewer: (reviewer: string) => void;
  setScenario: (scenario: PreviewScenario) => void;
}

export const useSession = create<SessionState>((set) => ({
  reviewer: "",
  scenario: "valid",
  setReviewer: (reviewer) => set({ reviewer }),
  setScenario: (scenario) => set({ scenario }),
}));
